// extracted by mini-css-extract-plugin
export default {"checkbox-group":"checkbox-group_checkbox-group__dbnDE","label":"checkbox-group_label__28jn8"};